// Modules:
import React, { useState, useEffect, useContext } from 'react';

// Style:
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// Utils:
import TopicConfigContext from 'utilities/topicConfigContext';
import { handleFetchError, formatColumns } from 'utilities/utils';
import { sortNcdmsStatewideFirst } from 'utilities/ncdmUtils';
import { useErrorHandler } from 'react-error-boundary';

// Components:
import AttributeTable from './AttributeTable';

const styles = {
    '&.MuiTypography-root': {
        fontSize: '1em',
        color: 'black',
        marginRight: '0.625rem',
    },
};

const TableContent = ({ setMissingSuppressedModalOpen, stratification }) => {
    // // State // //
    const [data, setData] = useState([]);

    // // Context // //
    const { tab: currentTab } = useContext(TopicConfigContext);

    // // Hooks // //
    const handleError = useErrorHandler();

    // // Effects // //
    useEffect(() => {
        // Set table layers when this component mounts
        fetch(`${currentTab.tableSettings.url}`)
            .then(handleFetchError)
            .then((res) => res.json())
            .then((json) => {
                const {
                    tableTitle,
                    tableSettings: { infoID: id, infoTitle, columnHeaders },
                } = currentTab;
                const sortedJson = sortNcdmsStatewideFirst(json);
                const formattedTableData = {
                    id,
                    info: {
                        infoTitle,
                        columnHeaders,
                        tableTitle,
                    },
                    features: sortedJson,
                };
                setData([formattedTableData]);
            })
            .catch(handleError);
    }, [currentTab.tableSettings.url, setData, handleError, currentTab]);

    return data ? (
        <>
            <div className="table-title-subtitle-container">
                <Typography sx={styles}>{currentTab.tableTitle}</Typography>
                <Typography variant="p">{currentTab?.tableSubtitle}</Typography>
            </div>
            <Grid item xs={12}>
                <AttributeTable
                    tableData={data}
                    isLoading={!data.length}
                    currentTab={currentTab}
                    formatColumns={formatColumns}
                    setMissingSuppressedModalOpen={
                        setMissingSuppressedModalOpen
                    }
                    stratification={stratification}
                />
            </Grid>
        </>
    ) : null;
};

export default TableContent;
